/* eslint-disable no-fallthrough */
export const ACTION_TYPES = {
  SELECT_PRODUCT: 0,
  SET_PRODUCT_QTE: 1,
  UNSELECT_PRODUCT: 2,
};

export default function reducer(state, action) {
  let newState;
  switch (action.type) {
    case ACTION_TYPES.SELECT_PRODUCT: {
      newState = state.map((product) =>
        product.id === action.payload ? { ...product, selected: true } : product
      );
      return newState;
    }
    case ACTION_TYPES.UNSELECT_PRODUCT: {
      newState = state.map((product) =>
        product.id === action.payload
          ? { ...product, selected: false }
          : product
      );
      return newState;
    }

    case ACTION_TYPES.SET_PRODUCT_QTE: {
      const { productId, consumedQte } = action.payload;
      newState = state.map((product) =>
        product.id === productId ? { ...product, consumedQte } : product
      );
      return newState;
    }

    default:
      return state;
  }
}
